import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import teadImg from "../../../assest/teardownImage.jpeg";

const AddTearDownFees = ({
  isOpen,
  onClose,
  onAddProduct,
  setCode,
  twentyPercentTotal,
}) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [internalNotes, setInternalNotes] = useState("");

  const [selectedPricingValue, setSelectedPricingValue] =
    useState(twentyPercentTotal);
  const [projectSelectDate, setProjectSelectedDate] = useState("");
  const [projectSelectedHour, setProjectSelectedHour] = useState("12");
  const [projectSelectedMinute, setProjectSelectedMinute] = useState("00");
  const [projectSelectedPeriod, setProjectSelectedPeriod] = useState("AM");
  const [discountType, setDiscountType] = useState();
  const [discount, setDiscount] = useState();

  const generateRandomId = () => {
    return Math.floor(100000 + Math.random() * 900000); // Generates a 6-digit number
  };

  const handleAddProduct = () => {
    // const [startYear, startMonth, startDay] = projectSelectDate.split("-");
    // let startHour = parseInt(projectSelectedHour, 10);
    // const startMinute = parseInt(projectSelectedMinute, 10);

    // if (projectSelectedPeriod === "PM" && startHour < 12) startHour += 12;
    // if (projectSelectedPeriod === "AM" && startHour === 12) startHour = 0;

    // const combinedStartDate = new Date(
    //   Date.UTC(startYear, startMonth - 1, startDay, startHour, startMinute)
    // ).toISOString();

    const newProduct = {
      productId: generateRandomId().toString(),
      productCode: generateRandomId(),
      title,
      quantity: "1",
      description,
      internalNotes,
      tax: "0",
      discount: discount,
      discountType: discountType,
      selectedPricingValue,
      singleImage: teadImg,
      deliveryType: "tear",
      // startDate: combinedStartDate,
    };

    onAddProduct(setCode, newProduct);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0  flex justify-center items-center font-roboto ">
      <div className="bg-gray-100 rounded-2xl shadow-2xl w-[50%] ">
        {/* Header */}
        <div className="flex flex-row justify-between items-center px-6 py-4 bg-gradient-to-r bg-blue-600 rounded-t-2xl">
          <h2 className="text-xl font-bold text-white">
            Add Setup/Teardown fees
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-full hover:bg-blue-700 transition-colors duration-200"
          >
            <img
              className="w-4 h-4"
              alt="Close"
              src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgMzI5LjI2OSAzMjkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiIGNsYXNzPSIiPjxnPjxwYXRoIGQ9Ik0xOTQuOCAxNjQuNzcgMzIzLjAxMyAzNi41NTVjOC4zNDMtOC4zNCA4LjM0My0yMS44MjUgMC0zMC4xNjQtOC4zNC04LjM0LTIxLjgyNS04LjM0LTMwLjE2NCAwTDE2NC42MzMgMTM0LjYwNSAzNi40MjIgNi4zOTFjLTguMzQ0LTguMzQtMjEuODI0LTguMzQtMzAuMTY0IDAtOC4zNDQgOC4zNC04LjM0NCAyMS44MjQgMCAzMC4xNjRsMTI4LjIxIDEyOC4yMTVMNi4yNTkgMjkyLjk4NGMtOC4zNDQgOC4zNC04LjM0NCAyMS44MjUgMCAzMC4xNjRhMjEuMjY2IDIxLjI2NiAwIDAgMCAxNS4wODIgNi4yNWM1LjQ2IDAgMTAuOTIyLTIuMDkgMTUuMDgyLTYuMjVsMTI4LjIxLTEyOC4yMTQgMTI4LjIxNiAxMjguMjE0YTIxLjI3MyAyMS4yNzMgMCAwIDAgMTUuMDgyIDYuMjVjNS40NiAwIDEwLjkyMi0yLjA5IDE5LjA4Mi02LjI1IDguMzQzLTguMzQgOC4zNDMtMjEuODI0IDAtMzAuMTY0em0wIDAiIGZpbGw9IiNmZmZmZmYiIG9wYWNpdHk9IjEiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIGNsYXNzPSIiPjwvcGF0aD48L2c+PC9zdmc+"
            />
          </button>
        </div>

        {/* Body */}
        <div className="grid grid-cols-2 gap-5 p-6">
          {/* Product Title */}
          <div>
            <label className="block font-roboto text-md text-gray-900 mb-2">
              Setup/Teardown Title
            </label>
            <input
              type="text"
              placeholder="Product Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all duration-200"
            />
          </div>
          <div></div>
          {/* Selected Pricing Value */}
          <div>
            <label className="block font-roboto text-md text-gray-900 mb-2">
              Setup/Teardown Charge
            </label>
            <input
              type="number"
              placeholder="Selected Pricing Value"
              value={selectedPricingValue ?? ""}
              onChange={(e) => {
                const value = e.target.value;

                // Allow empty input for smooth deletion
                if (value === "") {
                  setSelectedPricingValue(null);
                  return;
                }

                // Parse to float and check for non-negative value
                const parsedValue = parseFloat(value);
                if (!isNaN(parsedValue) && parsedValue >= 0) {
                  setSelectedPricingValue(parsedValue);
                }
              }}
              className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all duration-200"
            />
          </div>
          {/* discount */}
          <div className="flex flex-col ">
            <label className="block font-roboto text-md text-gray-900 mb-2">
              Discount:
            </label>
            <div className="flex gap-2">
              <select
                value={discountType}
                onChange={(e) => setDiscountType(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all duration-200"
              >
                <option selected>Select discount type</option>
                <option value="%">%</option>
                <option value="$">$</option>
              </select>
              <input
                type="number"
                value={discount}
                onChange={(e) => setDiscount(e.target.value)}
                placeholder="Add discount value"
                // placeholder={`${product?.discount || ''} ${product?.discountType || ''}`}
                className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all duration-200"
              />
            </div>
          </div>

          {/* Description */}
          <div>
            <label className="block font-roboto text-md text-gray-900 mb-2">
              Setup/Teardown Description
            </label>
            <textarea
              placeholder="Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all duration-200"
            />
          </div>

          {/* Internal Notes */}
          <div>
            <label className="block font-roboto text-md text-gray-900 mb-2">
              Setup/Teardown Internal Notes
            </label>
            <textarea
              placeholder="Internal Notes"
              value={internalNotes}
              onChange={(e) => setInternalNotes(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all duration-200"
            />
          </div>
          {/* <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Start Date
            </label>
            <input
              type="date"
              value={projectSelectDate}
              onChange={(e) => setProjectSelectedDate(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Start Time
            </label>
            <div className="flex gap-2">
              <select
                value={projectSelectedHour}
                onChange={(e) => setProjectSelectedHour(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
              >
                {Array.from({ length: 12 }, (_, i) => i + 1).map((hour) => (
                  <option key={hour} value={hour < 10 ? `0${hour}` : hour}>
                    {hour < 10 ? `0${hour}` : hour}
                  </option>
                ))}
              </select>
              <select
                value={projectSelectedMinute}
                onChange={(e) => setProjectSelectedMinute(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
              >
                {Array.from({ length: 12 }, (_, i) => i * 5).map((minute) => (
                  <option
                    key={minute}
                    value={minute < 10 ? `0${minute}` : minute}
                  >
                    {minute < 10 ? `0${minute}` : minute}
                  </option>
                ))}
              </select>
              <select
                value={projectSelectedPeriod}
                onChange={(e) => setProjectSelectedPeriod(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
              >
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </div>
          </div> */}
        </div>

        {/* Footer */}
        <div className="p-6 flex justify-start bg-gray-50 border-t border-gray-200">
          <button
            onClick={handleAddProduct}
            className="w-56 py-3 font-roboto  bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg focus:ring-4 focus:outline-none focus:ring-blue-300 transition-all"
          >
            Add Teardown Fees
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddTearDownFees;
